import { useParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';

import { Example } from '../Example';

export const PublicExample = () => {
  const { exampleId } = useParams();

  return (
    <div className="px-4 py-4">
      <Breadcrumbs />
      <Example exampleId={exampleId} />
    </div>
  );
};
